import { render, staticRenderFns } from "./Grade10Landing.vue?vue&type=template&id=06d684a3"
import script from "./Grade10Landing.vue?vue&type=script&lang=js"
export * from "./Grade10Landing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports